import React from 'react';
import { Edit2, Trash2, Power, Package } from 'lucide-react';

const ProductDetailPanel = ({ product, onEdit, onToggleStatus, onDelete }) => {
  if (!product) {
    return (
      <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-6 font-oranienbaum shadow-sm flex flex-col items-center justify-center min-h-[200px]">
        <Package size={32} className="text-white/15 mb-3" />
        <p className="text-white/30 font-oranienbaum text-sm text-center">
          Selecciona un producto para ver sus detalles
        </p>
      </div>
    );
  }

  return (
    <div className="bg-[#1A1A1A] rounded-xl border border-white/8 p-5 space-y-5 font-oranienbaum shadow-sm">
      {/* Header */}
      <div className="flex justify-between items-start">
        <h2 className="text-base font-bold font-oranienbaum text-[#D6EF4E]">Información</h2>
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-oranienbaum font-medium border ${
            product?.activo
              ? 'bg-[#3A7F6B]/15 text-[#3A7F6B] border-[#3A7F6B]/30'
              : 'bg-white/5 text-white/40 border-white/10'
          }`}
        >
          {product?.activo ? 'Activo' : 'Desactivado'}
        </span>
      </div>

      {/* Fields */}
      <div className="space-y-4">
        <div>
          <label className="block text-xs font-oranienbaum text-white/40 mb-1">
            Nombre del Producto
          </label>
          <p className="text-sm font-oranienbaum text-white font-medium">{product?.nombre}</p>
        </div>
        <div>
          <label className="block text-xs font-oranienbaum text-white/40 mb-1">
            Fecha de Creación
          </label>
          <p className="text-sm font-oranienbaum text-white/70">
            {product?.createdAt ? new Date(product?.createdAt)?.toLocaleDateString('es-ES') : 'N/A'}
          </p>
        </div>
      </div>

      {/* Actions */}
      <div className="pt-4 border-t border-white/8 space-y-2">
        <button
          onClick={() => onEdit(product)}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-[#8097D6]/15 border border-[#8097D6]/30 rounded-lg text-[#8097D6] text-sm font-oranienbaum hover:bg-[#8097D6]/25 transition-colors"
        >
          <Edit2 className="w-4 h-4" />
          Editar Producto
        </button>
        <button
          onClick={() => onToggleStatus(product)}
          className={`w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg border text-sm font-oranienbaum transition-colors ${
            product?.activo
              ? 'bg-[#E05252]/10 border-[#E05252]/30 text-[#E05252] hover:bg-[#E05252]/20'
              : 'bg-[#3A7F6B]/10 border-[#3A7F6B]/30 text-[#3A7F6B] hover:bg-[#3A7F6B]/20'
          }`}
        >
          <Power className="w-4 h-4" />
          {product?.activo ? 'Desactivar' : 'Activar'}
        </button>
        <button
          onClick={() => onDelete(product?.id)}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-[#E05252]/10 border border-[#E05252]/30 rounded-lg text-[#E05252] text-sm font-oranienbaum hover:bg-[#E05252]/20 transition-colors"
        >
          <Trash2 className="w-4 h-4" />
          Eliminar Producto
        </button>
      </div>
    </div>
  );
};

export default ProductDetailPanel;